import { onMounted, onUnmounted, unref, watch } from 'vue'

import { useLayoutStore } from '@/features/layout/useLayoutStore.js'

export function useHeaderRightActions(actions) {
  const layoutStore = useLayoutStore()

  onMounted(() => {
    layoutStore.setHeaderRightActions(unref(actions))
  })

  onUnmounted(() => {
    layoutStore.resetHeaderRightActions()
  })

  watch(
    () => unref(actions),
    value => {
      layoutStore.setHeaderRightActions(value)
    },
    {
      deep: true,
      immediate: true,
    },
  )
}
